import { Alert, AlertTitle } from '@mui/material'
import { hasOffersDiscount } from './helper'
import DiscountTagIcon from '@mui/icons-material/Loyalty'
import { Types } from 'service-api'
import { i18WithDefault as t } from '@shared/locale'

interface SearchOffersMembershipAlertProps {
  hasMembershipsService?: boolean
  searchResults?: Types.APIBookingSearchClientDtoResponse['results']
  isDaycare?: boolean
}

export const SearchOffersMembershipAlert = ({
  hasMembershipsService,
  searchResults,
  isDaycare = false,
}: SearchOffersMembershipAlertProps) => {
  return hasMembershipsService && searchResults && hasOffersDiscount(searchResults, isDaycare) ? (
    <Alert icon={<DiscountTagIcon />} severity="info" sx={{ mb: 3 }}>
      <AlertTitle style={{ fontWeight: '600' }}>{t('searchResults.alert.membershipDiscount')}</AlertTitle>
    </Alert>
  ) : null
}
